//3rd Party Components
import React, { Fragment } from 'react';
import { useSelector } from "react-redux";

//Components
import Heading from '../components/CASA/Heading';

//Actions
import { getUrlSelector } from '../PortalStore/Selectors/EnvDataSelectors';
import { getPortalUrl } from '../components/Portal/Utilities';

export const PageNotFoundPage = () => {
    let standalone = useSelector(state => state.B2CSettings.items.standalone);
    let urlHome = useSelector(state => getUrlSelector(state, "Portal - Home URL"));

    const loc = getPortalUrl("/", standalone, urlHome); 
    const items = [
        {
            link: loc + '?standalone=true',
            text: 'myCASA'
        },
        {
            text: 'Page does not exist'
        }
    ];

    return (
        <Fragment>
            <Heading
                text="Page does not exist"
                subtext="We're sorry, but the page you were trying to view doesn't exist."
                breadcrumbs={items}
                showcrumbs={true}
                showback={false}>
            </Heading>

            <div>
                <a className="au-direction-link au-direction-link--left" href={loc + '?standalone=' + standalone}>Return to myCASA</a>
            </div>

        </Fragment>

    );
    
}

